import React, { useState } from 'react';
import Avatar from 'react-avatar';
import { Meta, ProfileContainer, Name } from './style';
import authStore from '../../../../store/auth';
import { Popover } from 'react-tiny-popover';
import Menu from './Menu';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { HiOutlineChevronUp } from 'react-icons/hi';

const Profile = ({ open, avatarSize = '36px' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const avatarName = authStore?.user?.name
    ?.split(' ')
    .map(name => name?.[0])
    .join(' ');

  const toggle = e => {
    e.stopPropagation();
    setIsOpen(v => !v);
  };

  const close = () => setIsOpen(false);

  return (
    <Popover
      isOpen={isOpen}
      onClickOutside={close}
      clickOutsideCapture={false}
      positions={['bottom', 'left']}
      align="end"
      // Sit above the sticky AppTopBar (z:10) and stepper (z:9) — without
      // this the menu is covered by the stepper bar when it overflows below.
      containerStyle={{ zIndex: '100' }}
      content={
        <div onMouseDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()}>
          <Menu closePopover={close} />
        </div>
      }
    >
      <ProfileContainer $open={isOpen} onClick={toggle}>
        <Meta open={open}>
          <Name>
            {authStore?.user &&
              authStore.user.name.split(' ').map((name, idx) => (
                <h3 className="name" key={idx}>
                  {name}
                </h3>
              ))}
          </Name>
          <h3 className="email">{authStore?.user?.username}</h3>
        </Meta>
        <Avatar size={avatarSize} color="#058F92" name={avatarName || ''} round />
        {isOpen ? (
          <HiOutlineChevronUp size={16} color="#868E96" />
        ) : (
          <HiOutlineChevronDown size={16} color="#868E96" />
        )}
      </ProfileContainer>
    </Popover>
  );
};

export default Profile;
